module.exports = __webpack_public_path__ + "img/pic_register2.1766306608134.png";